module.exports = __webpack_public_path__ + "static/media/p042_words.ca4c3ad4.txt";